import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';
import { BillingSubscription } from '/@/modules/billing/models/BillingSubscription';
import { BillingCustomer } from '/@/modules/billing/models/BillingCustomer';
import { BillingCard } from '/@/modules/billing/models/BillingCard';

export class BillingCheckoutSuccess extends BaseModel {
  /**
   * @var {BillingSubscription}
   */
  subscription;

  /**
   * @var {BillingCustomer}
   */
  customer;

  /**
   * @var {BillingCard}
   */
  card;

  constructor(model = {}) {
    super();

    this.subscription = BillingSubscription.mapModel(model.subscription);
    this.customer = BillingCustomer.mapModel(model.customer);
    this.card = BillingCard.mapModel(model.subscription);
  }
}
